import { Component, ElementRef, ViewChild } from '@angular/core';
import { CustomerType, PageBase } from 't4core';
import { T4DatatableWidget } from '../../../../t4common/';




@Component({
    selector: 'customers',
    styleUrls: ['./customers.component.css'],
    templateUrl: './customers.component.html',
})
export class CustomersComponent extends PageBase {

    @ViewChild("datatable", {static: false}) table: T4DatatableWidget;
    public customerType = CustomerType;

    constructor(el: ElementRef) {
        super(el, "CustomerList");
    }

    public update() {
        this.table.update();
    }
}
